import { useRouter as useNextRouter } from 'next/router';

const useRouter = () => {
  const { push: nextPush, ...rest } = useNextRouter()
  const customPush = ({
    pathname,
    query,
  }: {
    pathname: string
    query?: Record<string, any>
  }, options: any) => {
    if (query) {
      const generateQuery = new URLSearchParams(query).toString()
      nextPush(`${pathname}/?${generateQuery}`, null, options)
    } else {
      nextPush(pathname, null, options);
    }
  }

  return { ...rest, push: customPush }
}

export default useRouter